
import { useCallback, useEffect, useState, useRef } from "react";

import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Calendar } from "primereact/calendar";
import { formatDate } from "../../helpers/helper";
import { Toast } from "primereact/toast";

import { PremioGeral } from "../../components/Tabelas/PremioGeral";
import { PremioQualidade } from "../../components/Tabelas/PremioQualidade";
import { PremioTurma } from "../../components/Tabelas/PremioTurma";

import Loading from "../../components/Loading";
import Menu from "../../components/Menu";

import api from "../../services/api";

import { useLocation, useNavigate } from "react-router";
import { ToggleButton } from "primereact/togglebutton";


const initialState = {
    "colaboradores": [],
    "producao": [],
    "title": "",
    "defeitos_sem_turma": 0
}

export function Premio() {
    const navigate = useNavigate();
    const location = useLocation();

    const [data, setData] = useState({...initialState});

    const [isLoading, setIsLoading] = useState(false);
    const [initialDate, setInitialDate] = useState(location.state?.initialDate ?? new Date());;
    const [finalDate, setFinalDate] = useState(location.state?.finalDate ?? new Date());;
    const [ocultarNomes, setOcultarNomes] = useState(false);

    const toast = useRef();

    const showError = (error) => {
        toast.current.show({
            summary: 'Ocorreu um Erro',
            severity: 'error',
            detail: error.response ? error.response.data.message : error.message
        });
    }

    const handleSearch = _ => {
        setIsLoading(true);
        api.get("qualidade/premio", {
            params: {
                "data_inicial": formatDate(initialDate),
                "data_final": formatDate(finalDate)
            }
        }).then((response) => {
            setData(response.data);
            setIsLoading(false);
        }).catch((error) => {
            setIsLoading(false);
            showError(error);
        });
    }

    const fetchData = useCallback(() => {
        setIsLoading(true);
        api.get("qualidade/premio").then((response) => {
            setIsLoading(false);
            setData(response.data);
        }).catch((error) => {
            setIsLoading(false);
            showError(error);
        });
    }, []);

    useEffect(() => {
        if (location.state?.initialDate && location.state?.finalDate) {
            handleSearch();
        } else {
            fetchData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.state]);

    if(isLoading) {
        return <Loading />
    }

    return (
        <div>
            <Toast ref={toast} />
            <Menu />

            <Card
                className="p-m-1"
            >
                <div className="p-d-flex p-flex-row">
                    <Calendar
                        className="p-m-1"
                        dateFormat="dd/mm/yy"
                        mask="99/99/9999"
                        onChange={e => setInitialDate(e.value)}
                        placeholder="Selecione a Data Inicial"
                        value={initialDate}
                    />
                    <Calendar
                        className="p-m-1"
                        dateFormat="dd/mm/yy"
                        mask="99/99/9999"
                        onChange={e => setFinalDate(e.value)}
                        placeholder="Selecione a Data Final"
                        value={finalDate}
                    />
                    <Button 
                        className="p-m-1"
                        icon="pi pi-search"
                        onClick={() => handleSearch()}
                    />
                    <Button
                        className="p-m-1 p-button-danger"
                        icon="pi pi-ban"
                        label="Defeitos"
                        onClick={() => {
                            navigate('/defeitos/premio/defeitos_turma', {
                                state: { initialDate, finalDate }
                            });
                        }}
                    />
                </div>
                <div>
                    {data.colaboradores.length > 0 && (
                        <div className="p-mt-3">
                            <div className="p-mb-4 p-pb-3" style={{ borderBottom: '2px solid #e9ecef' }}>
                                <div>
                                    <h2 className="p-m-0" style={{ color: '#2c3e50', fontSize: '1.75rem' }}>
                                        Relatório de Qualidade
                                    </h2>
                                    <span className="p-ml-1" style={{ color: '#7f8c8d', fontSize: '1.1rem', fontWeight: '500' }}>
                                        {data.title}
                                    </span>
                                </div>
                                <div className="p-d-flex p-ai-center p-mt-2 p-ml-1" style={{ gap: '1rem' }}>
                                    <div style={{ backgroundColor: '#e3f2fd', color: '#0d47a1', padding: '0.5rem 1rem', borderRadius: '6px', border: '1px solid #bbdefb', textAlign: 'center' }}>
                                        <span style={{ fontSize: '0.8rem', textTransform: 'uppercase', fontWeight: 'bold', display: 'block' }}>Produção Total</span>
                                        <span style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>{Intl.NumberFormat('pt-BR').format(data.producao)} m</span>
                                    </div>

                                    <div style={{ backgroundColor: '#fff3cd', color: '#856404', padding: '0.5rem 1rem', borderRadius: '6px', border: '1px solid #f8e3a5', textAlign: 'center' }}>
                                        <span style={{ fontSize: '0.8rem', textTransform: 'uppercase', fontWeight: 'bold', display: 'block' }}>Defeitos s/ Turma</span>
                                        <span style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>{Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 }).format(data.defeitos_sem_turma)} m</span>
                                    </div>
                                </div>
                            </div>
                            <ToggleButton
                                checked={ocultarNomes} 
                                onChange={(e) => setOcultarNomes(e.value)} 
                                onLabel="Mostrar Nomes" 
                                offLabel="Ocultar Nomes" 
                                onIcon="pi pi-eye" 
                                offIcon="pi pi-eye-slash" 
                                className={ocultarNomes ? "p-button-primary" : "p-button-warning"}
                            />
                            

                            <div className="p-mt-4">
                                <PremioGeral 
                                    data={data.colaboradores} 
                                    producaoTotal={data.producao} 
                                    ocultarNomes={ocultarNomes}
                                />

                                <div className="p-mt-5">
                                    <PremioQualidade 
                                        data={data.colaboradores} 
                                        producaoTotal={data.producao} 
                                        ocultarNomes={ocultarNomes}
                                    />
                                </div>
                                
                                <div className="p-mt-5">
                                    <PremioTurma 
                                        data={data.colaboradores} 
                                        producaoTotal={data.producao} 
                                        producaoTurmas={data.producao_turmas} 
                                        ocultarNomes={ocultarNomes}
                                        initialDate={initialDate}
                                        finalDate={finalDate}
                                    />
                                </div>
                            </div>

                        </div>
                    )}
                </div>
            </Card>
        </div>
    )
}